<template >
  <div class="formio-component formio-component-panel formio-component-panel" :class="ctx.customClass"
    :id="ctx.key">
    <div class="mb-2 card border">
        <div ref="header" class="card-header bg-default">
            <span class="mb-0 card-title">{{ctx.label}}</span>
        </div>  
        <div ref="nested-panel" class="card-body">
             <template v-for="component in ctx.components">
                <component
                    :is="component.type"
                    :key="component.key"
                    :theme="theme"
                    :ctx-a="component"
                    :store="store"
                ></component>
            </template>
        </div>
    </div>
  </div>
</template>

<script>
import SimpleComponentMixin from '../../mixins/SimpleComponentMixin';
import defaultSchema from './panelDefaultSchema';

// TODO: Add a better key for v-for
export default {
  name: 'panel',
  mixins: [SimpleComponentMixin],
  beforeCreate() {
    this.defaultSchema = defaultSchema;
  }
};
</script>
